export const StepperPage = {
  selectModel: 0,
  customization: 1,
  personalize: 2,
  reserve: 3
};
